import { GridLegacy } from "@mui/material";
import React from "react";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import FormJson from "../../../components/Forms/FormJson";
import FormTextTC from "../../../components/Forms/FormTextTC";

function Algemeen() {
  return (
    <Card>
      <CardBody style={{ padding: 16 }}>
        <GridLegacy container spacing={1}>
          <FormTextTC name={"type"} tDefault={"Type"} tKey={"defaultsettings.form.algemeen.label.active"} />
          <FormTextTC name={"starts"} tDefault={"Start datetime"} tKey={"defaultsettings.form.starts"} />
          <FormTextTC name={"ends"} tDefault={"Stop datetime"} tKey={"defaultsettings.form.ends"} />
          {/* <FormControlledInputTC
            name={"starts"}
            tKey={"defaultsettings.form.starts"}
            tDefault={"Start time"}
            type={"datetime"}
            nullable
          />
          <FormControlledInputTC
            name={"ends"}
            tKey={"defaultsettings.form.ends"}
            tDefault={"End time"}
            type={"date"}
            nullable
          /> */}
          <FormJson name={"settings"} tDefault={"JSON Data"} tKey={"vestigingen.form.defaultsettings.headers.json"} />
        </GridLegacy>
      </CardBody>
    </Card>
  );
}

export default Algemeen;
